
export interface BgLocationPermissionPlugin {
  echo(options: { level: string, message: string }): Promise<{ value: string }>;
  requestPermissions(): Promise<{ location: string }>;
  checkPermissions(): Promise<{ location: string }>;
  openSettings(): Promise<{ status: string }>;
  isLocationServicesEnabled(): Promise<{ enabled: boolean }>;
  requestEnableLocationServices(): Promise<{ enabled: boolean }>;
  sendLocation(options: LocationUpdateOptions): Promise<{ status: string }>;
  startService(): Promise<{ status: string }>;
  startMonitoring(options?: { sensitivity?: number; stillDelayMs?: number }): Promise<void>;
  stopMonitoring(): Promise<void>;
  isRunning(): Promise<{ running: boolean }>;
  showDutyNotification(options: DutyNotificationOptions): Promise<void>;
  hideDutyNotification(): Promise<void>;
  addListener(eventName: 'motionState', listenerFunc: (data: { state: 'moving'|'still'|'unknown' }) => void): any;
  requestBluetoothPermission(): Promise<{ bluetooth: string }>;
}

export interface DutyNotificationOptions {
  shiftStartsAtMs?: number;
  shiftEndsAtMs: number;
  shiftStartLabel?: string;
  shiftEndLabel: string;
  shiftName?: string;
}

export interface LocationUpdateOptions {
  baseUrl: string;
  authToken: string;
  userId: string;
  tenantId: string;
  latitude: number;
  longitude: number;
}
